import { useState, useEffect } from "react";
import { getRoundCase, getDates, getFormatValue, isMultiFormat, calcHandicapPair, calcMinDrive } from "./tournamentHelper";
import moment from "moment";
import { getTeeSlotByTournamentTeeID } from "../api/tournamentAPI";


const TournamentRoundTable=(props)=> {
    const ShotgunString      = "Shot Gun Start";
    const SplitShotgunString = "Split Shot Gun Start";
    const FormatsWithInputs = ['Net Stableford', 'Foursomes', 'Scramble', 'Greensome', 'Fourball Betterball', 'Cumulative Stableford', 'Betterball Bogey', 'Scramble - Stroke Play Net', 'Fourball Net Stableford', 'Betterball Greensome', 'Scramble Foursomes', 'DevilsDoubles666'];
       
    const [pageData, setPageData] = useState({});
    const [showHandicapCategoryModal,  setShowHandicapCategoryModal]  = useState(false);
    const [handicapCategory, setHandicapCategory] = useState([]);   // local working copy edited inside the modal - NOT committed to roundList until Save
    const [activeRoundIndex, setActiveRoundIndex] = useState(null);
    //#region Effects     

    useEffect(() => {
        setRoundData()
    }, [])

    //#endregion

    const setRoundData =()=> {       
        const { tMaster, tData} = props;

        const currentCase = getRoundCase(tMaster?.Days, tMaster?.Round);
        const roundDates  = getDates(tMaster?.StartDate, tMaster?.EndDate);

        let pData = { RoundCase: currentCase, Dates: roundDates, Rounds: tMaster.Round };
        if(!!tData) {           
            pData.TeeOffOptions        = tData.TeeOffOptions;
            pData.Formats              = tData.TournamentFormats.filter(f => f.Type == tMaster.Type);
            pData.TournamentTee        = tData.TournamentTee;
            pData.AfternoonSessionTime = tData.AfternoonSessionTime;
        }
        
        setPageData(pData);
              
        setTimeout(() =>{
            $(`.slot-picker`).timepicker({ minuteStep: 10, defaultTime: '07:00 AM' }).on('change', function(){
                const index = $(this).attr('data-index');
                const field = $(this).attr('data-field');
                const value = $(this).val();                
                
                onChangeHandler(field, value, index);
            });               
        }, 500);    
    }
    
    //#region handlers    
   
    const removeRound  = (roundIndex)=>{
        const filtered = props.roundList.filter((r,i) => (i != roundIndex));
        props.setRoundList(filtered);
    }

    const addRound =()=> {
        const { tMaster } = props;

        let rounds       = props.roundList;
        const roundDates = getDates(tMaster?.StartDate, tMaster?.EndDate);
        const roundDt    = roundDates[roundDates.length - 1];

        const defaultFormat = (pageData?.Formats[0]?.Format);
        const formatValue   = getFormatValue(defaultFormat);

        const isMulti = isMultiFormat(defaultFormat);
                   
        rounds.push({
            ID                     : 0,
            TournamentTeeID        : 0,
            Round                  : tMaster.Round,
            Date                   : roundDt.value,
            Format                 : defaultFormat,
            TeeOffOption           : pageData.TeeOffOptions[0],
            TeeOffTime             : '',
            TeeOffTimeSplit        : '',
            LowerMiddle            : isMulti ? 0 : (!!formatValue ? formatValue.lowerMiddle : 0),
            Middle                 : isMulti ? 0 : (!!formatValue ? formatValue.middle : 0),
            Lower                  : isMulti ? 0 : (!!formatValue ? formatValue.lower : 0),
            Higher                 : isMulti ? 0 : (!!formatValue ? formatValue.higher : 0),
            MinDrive               : isMulti ? 0 : (!!formatValue ? formatValue.minDrive : 0),
            MorningRegisterLimit   : 0,
            AfternoonRegisterLimit : 0,
            Active: 'Y',
            RoundFormat            : isMulti ? formatValue.map(f => ({ ...f })) : null,
        });      

        props.setRoundList(([...rounds]));
    }    

    const onChangeHandler =(field, value, rowIndex)=> { 
        if(['Format','TournamentTeeID', 'TeeOffOption'].includes(field)) {          
            props.setRoundList((d)=>{
                const currentRound = d[rowIndex];        
                //check rounds with same roundNo 
                const newRounds = d?.map((r,i)=>{
                    if(i == rowIndex || r.Round == currentRound?.Round){
                        if(field == 'Format'){ //Change format fields of same rounds --
                            const formatValue = getFormatValue(value); 
                            const isMulti = isMultiFormat(value);
                            if (i !== rowIndex) r.Format = value;

                            if (isMulti) {
                                r.RoundFormat = formatValue.map(f => ({ ...f }));
                                r.Higher      = 0;
                                r.Lower       = 0;
                                r.Middle      = 0;
                                r.LowerMiddle = 0;
                                r.MinDrive    = 0;
                            } else {
                                r.RoundFormat = null;
                                r.Higher      = formatValue ? formatValue?.higher      : 0;
                                r.Lower       = formatValue ? formatValue?.lower       : 0;
                                r.Middle      = formatValue ? formatValue?.middle      : 0;
                                r.LowerMiddle = formatValue ? formatValue?.lowerMiddle : 0;
                                r.MinDrive    = formatValue ? formatValue?.minDrive    : 0;
                            }
                        }        
                            
                        if(field == 'TournamentTeeID') r.TournamentTeeID = value;  //Change Tee of same rounds
                        if(field == 'TeeOffOption'){ //Change TeeOffOption of same rounds
                            r.TeeOffOption = value;
                            if(!!value && value?.includes("Shot Gun")){                            
                                r.TournamentTeeID = ( pageData?.TournamentTee[0]?.ID || 0)                       
                            }
                        } 
                        
                        return ({...r,[field]: value})
                    }else{
                        return r
                    }                    
                });
                return newRounds;    
            });
        }else if(['Higher', 'Lower'].includes(field)){      
            //Handles Dynamic HC_% Calculation for the FLAT (single-format) rounds.
            //Multi-format rounds don't hit this path — they're edited through the
            //Handicap Category modal instead (see handleModalFieldChange below).
            props.setRoundList((d)=>{              
                const currentRound = d[rowIndex];     
                const newRounds = d?.map((r,i)=>{
                    if(i == rowIndex || r.Round == currentRound?.Round){
                        const { Higher, Lower } = calcHandicapPair(r?.Format, field, value, r?.Higher, r?.Lower);
                        return ({...r, Higher, Lower});
                    }else{
                        return r
                    }                    
                });
                return newRounds;    
            });
        }else if(field == "MinDrive"){
            props.setRoundList((d)=>{              
                const currentRound = d[rowIndex];        
                const newRounds = d?.map((r,i)=> {
                    if(i == rowIndex || r.Round == currentRound?.Round){
                        return ({...r, MinDrive: calcMinDrive(r?.Format, value)});
                    }else{
                        return r
                    }                    
                });
                return newRounds;    
            });
        }else{
            props.setRoundList((d) => {
                const newRound = d?.map((c,i)=> ((i== rowIndex)? ({...c,[field]: value}) : c)); 
                return newRound;
            });
        }                          
    } 
  
    const getSessionLimitElement = (elementIndex, roundData) => {
        const { AfternoonSessionTime }   = pageData;
        const {TeeOffOption, TeeOffTime, MorningRegisterLimit, AfternoonRegisterLimit} = roundData;
        let isMorning    = 'N'
        let isAfternoon  = 'N'
        if (props.teeSheet && props.teeSheet.length > 0) {
            if(TeeOffOption == 'Staggered Start' || TeeOffOption == 'Split Staggered Start') {
                    const startTime     = moment(props.teeSheet[0].Slot, 'h:mm A');
                    const endTime       = moment(props.teeSheet[props.teeSheet.length - 1].Slot, 'h:mm A');
                    const afternoonTime = moment(AfternoonSessionTime, 'h:mm A');
                    isMorning     = startTime.isBefore(afternoonTime) ? 'Y' : 'N';
                    isAfternoon   = endTime.isSameOrAfter(afternoonTime) ? 'Y' : 'N';
            } else {
                if (TeeOffOption == "Split Shot Gun Start") {
                    isMorning   = "Y";
                    isAfternoon = "Y";
                } else {
                    isMorning = moment(TeeOffTime, 'hh:mm A').isBefore(moment(AfternoonSessionTime, 'hh:mm A')) ? 'Y' : 'N'
                    isAfternoon = isMorning == "Y" ? "N" : "Y";
                }
            }
        }
        return (
            <>
                {isMorning == 'Y' && (
                    <div className= "round-MorningLimit margin-t15" id={`divMorningLimit${elementIndex}`}> <h6>Morning max registration</h6> 
                        <input className="form-control" id={`txtMorningLimit${elementIndex}`} name={`txtMorningLimit${elementIndex}`} type="number"
                            disabled={props?.flags?.IsRegister}
                            value={MorningRegisterLimit || 0} onChange={({target}) => onChangeHandler('MorningRegisterLimit', parseInt(target.value), elementIndex)}
                        />
                    </div>
                )}
                {isAfternoon == 'Y' && (
                    <div className={`round-AfternoonLimit margin-t10`} id={`divAfternoonLimit${elementIndex}`}> <h6>Afternoon max registration</h6> 
                        <input className="form-control" id={`txtAfternoonLimit${elementIndex}`} name={`txtAfternoonLimit${elementIndex}`} type="number"
                            disabled={props?.flags?.IsRegister}
                            value={AfternoonRegisterLimit || 0} onChange={({target}) => onChangeHandler('AfternoonRegisterLimit', parseInt(target.value), elementIndex)}
                        />
                    </div>   
                )}
            </>
        )
        // const isAfternoon = moment(TeeOffTime, 'hh:mm A').isSameOrAfter(moment(AfternoonSessionTime, 'hh:mm A'));        

        // //Hides morning session if shotgun and  teeoff time is morning || visible for other teeOffOptions
        // //Shows afternoon session if shotgun and teeOff time is afternoon || visible for other teeOffOptions
        // return (<>
        //     {(TeeOffOption != ShotgunString|| (TeeOffOption == ShotgunString && !isAfternoon)) &&(
        //         <div className= "round-MorningLimit margin-t15" id={`divMorningLimit${elementIndex}`}> <h6>Morning max registration</h6> 
        //             <input className="form-control" id={`txtMorningLimit${elementIndex}`} name={`txtMorningLimit${elementIndex}`} type="number"
        //                 disabled={props?.flags?.IsRegister}
        //                 value={MorningRegisterLimit || 0} onChange={({target}) => onChangeHandler('MorningRegisterLimit', parseInt(target.value), elementIndex)}
        //             />
        //         </div>   
        //     )}
            
        //     {(TeeOffOption != ShotgunString || (TeeOffOption == ShotgunString && isAfternoon)) && (
        //         <div className={`round-AfternoonLimit margin-t10`} id={`divAfternoonLimit${elementIndex}`}> <h6>Afternoon max registration</h6> 
        //             <input className="form-control" id={`txtAfternoonLimit${elementIndex}`} name={`txtAfternoonLimit${elementIndex}`} type="number"
        //                 disabled={props?.flags?.IsRegister}
        //                 value={AfternoonRegisterLimit || 0} onChange={({target}) => onChangeHandler('AfternoonRegisterLimit', parseInt(target.value), elementIndex)}
        //             />
        //         </div>   
        //     )}
        // </>);
    }

    const getFormatInputs =(elementIndex, roundData)=>{
        let defaultVal = getFormatValue(roundData?.Format);
        const isMulti = isMultiFormat(roundData?.Format);
        return(<>
            <div className="round-handicap row margin-t10">
                {roundData.Format != "Scramble - Stroke Play Net" && (
                    isMulti
                    ? (
                        <>
                            <button id="btnHoleCheck" type="button" className="btn btn-brand d-inline-block bg-info text-white font-weight-bold" data-toggle="modal" data-target="#handicapCategoryModal"
                                    onClick={() => {
                                        // FIX: clone into a fresh working copy so edits inside
                                        // the modal never mutate roundList[elementIndex].RoundFormat
                                        // directly - only Save should commit changes.
                                        const seed = (roundData.RoundFormat || defaultVal).map(f => ({ ...f }));
                                        setHandicapCategory(seed);
                                        setActiveRoundIndex(elementIndex);
                                        setShowHandicapCategoryModal(true);
                                    }}>
                                    <i className="la la-plus"></i>Handicap Category
                            </button>
                        </>
                      )
                    :(
                        <>
                            <div className={`col-sm-${defaultVal?.isMin ? 4 : 6}`}>
                                <span> {defaultVal?.label1} Handicap % </span>
                                <input type="number" className="form-control handicap-per" maxLength={3}
                                    value={roundData?.Higher} disabled={props?.flags?.IsDrawCreated}
                                    onChange={({ target }) => onChangeHandler("Higher", parseInt(target.value), elementIndex)}
                                />
                            </div>
                            <div className={`col-sm-${defaultVal?.isMin ? 4 : 6}`}>
                                <span> {defaultVal?.label2} Handicap % </span>
                                <input type="number" className="form-control handicap-per" maxLength={3}
                                    value={roundData?.Lower} disabled={props?.flags?.IsDrawCreated}
                                    onChange={({ target }) => onChangeHandler("Lower", parseInt(target.value), elementIndex)}
                                />
                            </div>
                        </>
                    )
                )}
                {!isMulti && roundData.Format == "Scramble - Stroke Play Net" && (
                    <>
                        <div className={`col-sm-${defaultVal?.isMin? 4 : 6}`}>
                            <span> {defaultVal?.label1} Handicap % </span>
                            <input type="number" className="form-control handicap-per" maxLength={3} 
                                value={roundData?.Lower}  disabled={props?.flags?.IsDrawCreated}
                                onChange={({target})=> onChangeHandler("Lower", parseInt(target.value), elementIndex)} 
                            />
                        </div>
                        <div className={`col-sm-${defaultVal?.isMin? 4 : 6}`}>
                            <span> {defaultVal?.label2} Handicap % </span>
                            <input type="number" className="form-control handicap-per" maxLength={3} 
                                value={roundData?.LowerMiddle}  disabled={props?.flags?.IsDrawCreated}
                                onChange={({target})=> onChangeHandler("LowerMiddle", parseInt(target.value), elementIndex)} 
                            />
                        </div>
                        <div className={`col-sm-${defaultVal?.isMin? 4 : 6}`}>
                            <span> {defaultVal?.label3} Handicap % </span>
                            <input type="number" className="form-control handicap-per" maxLength={3} 
                                value={roundData?.Middle}  disabled={props?.flags?.IsDrawCreated}
                                onChange={({target})=> onChangeHandler("Middle", parseInt(target.value), elementIndex)} 
                            />
                        </div>
                        <div className={`col-sm-${defaultVal?.isMin? 4 : 6}`}>
                            <span> {defaultVal?.label4} Handicap % </span>
                            <input type="number" className="form-control handicap-per" maxLength={3} 
                                value={roundData?.Higher}  disabled={props?.flags?.IsDrawCreated}
                                onChange={({target})=> onChangeHandler("Higher", parseInt(target.value), elementIndex)} 
                            />
                        </div>
                    </>
                )}
                
                {!isMulti && defaultVal?.isMin && (
                    <div className="col-sm-4">
                        <span> Min Drive </span>
                        <input type="number" className="form-control min-drive" maxLength={2} 
                           value={roundData?.MinDrive} disabled={props?.flags?.IsDrawCreated}
                           onChange={({target})=> onChangeHandler("MinDrive", parseInt(target.value), elementIndex)} 
                        />
                    </div>
                )}
            </div>
        </>)
    }

    // FIX: operates on the LOCAL `handicapCategory` working copy only.
    // `subIndex` is the index within the 2-row RoundFormat array (0/1),
    // never the round's index in roundList - that mix-up was the source
    // of the "editing one row breaks another round" bug.
    const handleModalFieldChange = (field, value, subIndex) => {
        setHandicapCategory((prev) =>
            prev.map((item, i) => {
                if (i !== subIndex) return item;

                if (field === "Higher" || field === "Lower") {
                    const { Higher, Lower } = calcHandicapPair(item?.TournamentRoundFormat, field, value, item?.Higher, item?.Lower);
                    return { ...item, Higher, Lower };
                }

                if (field === "MinDrive") {
                    // Greensome-inside-"Betterball Greensome" defaults to a
                    // MinDrive cap of 4 (see getFormatValue) rather than the
                    // standalone Greensome cap of 9 - confirm this is correct.
                    const capOverride = item?.TournamentRoundFormat === 'Greensome' ? 4 : undefined;
                    return { ...item, MinDrive: calcMinDrive(item?.TournamentRoundFormat, value, capOverride) };
                }

                // Any other field on the sub-row (shouldn't normally happen)
                return { ...item, [field]: value };
            })
        );
    };

    const saveHandicapCategory = () => {
        if (activeRoundIndex === null || activeRoundIndex === undefined) {
            setShowHandicapCategoryModal(false);
            return;
        }
 
        const savedFormat = handicapCategory.map(item => ({ ...item }));
 
        props.setRoundList((d) => {
            const currentRound = d[activeRoundIndex];
            return d.map((r) => {
                if (r.Round == currentRound?.Round) {
                    return { ...r, RoundFormat: savedFormat.map(item => ({ ...item })) };
                }
                return r;
            });
        });
 
        setShowHandicapCategoryModal(false);
        setActiveRoundIndex(null);
        setHandicapCategory([]);
    };

    const closeHandicapCategoryModal = () => {
        // Discard any unsaved edits made in the modal - roundList was never
        // touched, so this is a true cancel.
        setShowHandicapCategoryModal(false);
        setActiveRoundIndex(null);
        setHandicapCategory([]);
    };

    //#endregion  

    return(<>
        <div className="row mt-4">
            <div className="col-xl-12">
                <table id="table-round" className="table table-striped table-bordered table-hover">
                    <thead>
                        <tr>
                            <th style={{width:"9%"}}  > Round           </th>
                            <th style={{width:"25%"}} > Format          </th>
                            <th style={{width:"17%"}} > Date            </th>
                            <th style={{width:"17%"}} > Tee             </th>
                            <th style={{width:"18%"}} > Tee Off Options </th>
                            <th style={{width:"5%"}}  > Active          </th>
                            <th style={{width:"5%"}}  > Action          </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(props.roundList.length > 0) && props.roundList.map((r, index) => (
                            <tr key={index}>
                                <td className="round-no ddlTournamentRound" data-value={`${r?.Round}`}>
                                    <select id={`ddlRoundNo${index}`} name={`ddlRoundNo${index}`} className="form-control"
                                        value = {r?.Round}  disabled={(index == 0) || props?.flags?.IsDrawCreated}
                                        onChange={({target})=> onChangeHandler('Round', parseInt(target.value), index)}
                                    > 
                                        {[...Array(pageData.Rounds).keys()].map(n => ( <option key={n + 1} value={n + 1}> {n + 1} </option> ))}
                                   </select>
                                </td>

                                <td className="round-format">
                                    <select id={`ddlFormat${index}`} name={`ddlFormat${index}`} className="form-control" 
                                        value = {r?.Format || ''} disabled={props?.flags?.IsDrawCreated}
                                        onChange={({target})=> onChangeHandler('Format', target.value, index)}
                                    >
                                        {pageData?.Formats?.map((f) => ( <option key={f.Format} value={f.Format}> {f.Format} </option> ))}
                                    </select>

                                    {FormatsWithInputs.includes(r?.Format) && getFormatInputs(index,r)}
                                </td>
                              
                                <td className="round-date ddlTournamentDt">
                                    <select id={`ddlDate${index}`} name={`ddlDate${index}`} className="form-control"
                                        value = {moment(r?.Date).format('YYYY-MM-DD')} disabled={(index == 0) || props?.flags?.IsDrawCreated}
                                        onChange={({target})=> onChangeHandler('Date', target.value, index)}
                                    >
                                        {pageData?.Dates?.map((d,i) => ( <option key={i} value={d.value}> {d.label} </option> ))}
                                    </select>
                                </td>

                                <td className="round-teeId">
                                    {!r?.TeeOffOption.includes("Shot Gun") && (<>
                                        <select id={`ddlTeeTournament${index}`} name={`ddlTeeTournament${index}`} className="form-control"
                                            value={r?.TournamentTeeID || (pageData?.TournamentTee?.[0]?.ID || "0")}
                                            disabled={props?.flags?.IsDrawCreated}
                                            onChange={({target})=> onChangeHandler('TournamentTeeID', parseInt(target.value), index)}
                                        >
                                            {pageData?.TournamentTee?.map((t)=>( <option key={t.ID} value={t.ID}> {t.Name} </option> ))}
                                        </select>
                                    </>)}
                                    {(r.Round == 1) && getSessionLimitElement(index, r)}
                                </td>

                                <td className="round-teeOption">
                                    <select id={`ddlTeeOffOption${index}`} name={`ddlTeeOffOption${index}`} className="form-control" data-index={`${index}`}
                                        value = {r?.TeeOffOption} disabled={props?.flags?.IsDrawCreated}
                                        onChange={({target})=> onChangeHandler('TeeOffOption', target.value, index)}
                                    >
                                        {pageData?.TeeOffOptions?.map((t)=>( <option key={t} value={t}> {t} </option> ))}
                                    </select>
                                                                        
                                    <div className={`round-teeTime${index} margin-t10 ${r?.TeeOffOption?.includes(ShotgunString) ? '' : 'hidden'}`}>
                                        <h6>Tee Off Time</h6>                                        
                                        <input className={`form-control slot-picker ${(r?.TeeOffOption == ShotgunString || r?.TeeOffOption == SplitShotgunString) ? '' : 'hidden'}`} id={`txtTeeOffTime${index}`} name="txtTeeOffTime"  readOnly={true} type="text" 
                                            data-index={index} data-field={"TeeOffTime"} value = {r?.TeeOffTime || '07:00 AM'}                                                                                               
                                        />
                                        <input className={`form-control slot-picker margin-t10 ${(r?.TeeOffOption == SplitShotgunString)? '' : 'hidden'}`} id={`txtSplitTeeOffTime${index}`} name="txtSplitTeeOffTime" type="text" readOnly={true}  
                                            data-index={index} data-field={"TeeOffTimeSplit"} value = {r?.TeeOffTimeSplit || '10:00 AM'}                                                 
                                        />	      
                                    </div>
                                </td>

                                <td className="round-check text-center">
                                    <div className="kt-switch kt-switch--sm kt-switch--icon padding-t0">
                                        <label className="margin-b0">
                                            <input id={`roundCheck${index}`} name="chkActive" type="checkbox" 
                                                checked={(r?.Active == "Y")} disabled={props?.flags?.IsRegister}
                                                onChange={({target})=> onChangeHandler('Active', (target.checked)? "Y" : "N", index)}
                                            />
                                            <span className="lbl"></span>
                                        </label>
                                    </div>
                                </td>
                                
                                {(index != 0)&&(
                                    <td className="round-delete text-center">
                                        <button type="button" className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-template-edit" 
                                            onClick={()=> removeRound(index)} disabled={props?.flags?.IsDrawCreated}
                                        ><i className="flaticon2-rubbish-bin-delete-button"></i>
                                        </button>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                    {(pageData?.RoundCase == 4 && !props?.flags?.IsDrawCreated) && (
                        <tfoot className="bg-light">
                            <tr>
                                <td colSpan="7">
                                    <button type="button" className="btn btn-brand btn-icon-sm text-white d-inline pull-right"
                                        onClick={addRound} ><i className="la la-plus"></i> New
                                    </button>
                                </td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>
        </div>    
        {showHandicapCategoryModal && (
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Handicap Category</h5>
                            <button type="button" className="close" aria-label="Close" onClick={closeHandicapCategoryModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <HandicapCategoryModal
                                defaultVal={handicapCategory}
                                onChangeHandler={handleModalFieldChange}
                                disabled={props?.flags?.IsDrawCreated}
                            />
                        </div>
                        {/* FIX: the Save/Cancel footer was missing entirely -
                            saveHandicapCategory() existed but had no button
                            wired to it, so edits could never actually be
                            persisted from the UI. */}
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={closeHandicapCategoryModal}>
                                Cancel
                            </button>
                            <button type="button" className="btn btn-brand" onClick={saveHandicapCategory}
                                // disabled={props?.flags?.IsDrawCreated}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </>)
}

const HandicapCategoryModal = ({
    defaultVal = [],
    onChangeHandler,
    disabled = false,
}) => {
    return (
        <div className="handicap-category-list">
 
            {defaultVal.map((val, index) => (
                <div
                    className="d-flex justify-content-start align-items-center handicap-category-row mb-4"
                    key={`${val?.TournamentRoundFormat}-${index}`}
                >
                    {/* Format */}
                    <div className="col-sm-3 handicap-format">
                        <label className="handicap-label font-weight-bold">
                            Format
                        </label>
 
                        <div className="format-name mt-2 font-weight-bold">
                            {val?.TournamentRoundFormat || "N/A"}
                        </div>
                    </div>
 
                    {/* Handicap 1 */}
                    <div className="col-sm-3 handicap-field">
                        <label className="handicap-label font-weight-bold">
                            {val?.Label1 || "Higher"} Handicap %
                        </label>
 
                        <div className="input-group">
                            <input
                                type="number"
                                className="form-control handicap-input"
                                min="0"
                                max="100"
                                // disabled={disabled}
                                value={val?.Higher ?? ""}
                                onChange={({ target }) =>
                                    onChangeHandler(
                                        "Higher",
                                        target.value === "" ? "" : parseInt(target.value, 10),
                                        index
                                    )
                                }
                            />
                            <span className="input-group-text">%</span>
                        </div>
                    </div>
 
                    {/* Handicap 2 */}
                    <div className="col-sm-3 handicap-field">
                        <label className="handicap-label font-weight-bold">
                            {val?.Label2 || "Lower"} Handicap %
                        </label>
 
                        <div className="input-group">
                            <input
                                type="number"
                                className="form-control handicap-input"
                                min="0"
                                max="100"
                                // disabled={disabled}
                                value={val?.Lower ?? ""}
                                onChange={({ target }) =>
                                    onChangeHandler(
                                        "Lower",
                                        target.value === "" ? "" : parseInt(target.value, 10),
                                        index
                                    )
                                }
                            />
                            <span className="input-group-text">%</span>
                        </div>
                    </div>
 
                    {/* Minimum Drive */}
                    {!! val?.IsMin && (
                        <div className="col-sm-3 handicap-field min-drive-field">
                            <label className="handicap-label font-weight-bold">
                                {val?.TournamentRoundFormat == "Betterball" ? "Min Holes Count" : "Min Drive"}
                            </label>
 
                            <div className="input-group">
                                <input
                                    type="number"
                                    className="form-control handicap-input"
                                    min="0"
                                    max="9"
                                    // disabled={disabled}
                                    value={val?.MinDrive ?? ""}
                                    onChange={({ target }) =>
                                        onChangeHandler(
                                            "MinDrive",
                                            target.value === "" ? "" : parseInt(target.value, 10),
                                            index
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default TournamentRoundTable;